import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Matching from './Matching.component';

const ShortAnswerPeic = ({ alternatives }) => {
  const parsedAlternavies = useMemo(() => {
    return alternatives.map((alternative) => ({
      ...alternative,
      alternative_description: alternative.alternative_keywords,
      alternative_chosen_by_user: alternative.user_answer,
    }));
  }, [alternatives]);
  return <Matching alternatives={parsedAlternavies} />;
};

ShortAnswerPeic.propTypes = {
  alternatives: PropTypes.array,
};

export default ShortAnswerPeic;
